<div class="container_herramienta">
  <img src="assets/img/beneficios/LANDINGPAKTCAMBIES.png " class="img_toAnimate">
  <div class="alinearIzq">
      <h1 class="title-section">Servicio de portabilidad PAKTCAMBIES</h1>
      <img src="assets/img/beneficios/LANDINGPAKTCAMBIES.png " class="img_forMobil">
          <div class="descripcion_cont">
          <p>
            <b>PaKTCambies</b><br>
            Tus envíos más rápidos desde hoy.<br>
            ¡Es hora de un cambio! Optimiza tus envíos y accede a beneficios exclusivos diseñados 
            para impulsar tus operaciones con la calidad y rapidez de TufesaPack®.
          </p>
          <p>
              <b>¿Qué es PaKTCambies, la portabilidad de TufesaPack®?</b><br>
              Un programa único de portabilidad creado para clientes con contrato en otras paqueterías, 
              diseñado para clientes que buscan rapidez, seguridad y tarifas competitivas en sus envíos.<br>
              Al cambiarte a TufesaPack®, no solo mejoras tus envíos, también disfrutas de incentivos 
              que hacen más eficiente y rentable tu experiencia logística.
          </p>
          <p>
              <b style="text-decoration: underline;">Beneficios Prepago</b>
              <br>
              <li>Hasta <strong>10 envíos gratis</strong> para paquetes hasta de 40 kilogramos.</li>
              <li>Los envíos gratis podrán utilizarse durante los primeros 30 días naturales contados a partir de la activación del servicio.</li>
              <li>Para paquetes superiores a 40 kilogramos, los envíos gratis se otorgarán de forma diferida, liberándose 1 envío gratis por cada mes en que se cumpla el consumo mensual pactado, hasta agotar el total de 10 envíos.</li>
              <li>10% de descuento adicional en guías web, aplicable únicamente sobre la primera compra; las guías físicas generan costo adicional.</li>
          </p>
            <p>
              <b style="text-decoration: underline;">Beneficios Crédito</b>
              <br>
              <li><strong>5 envíos gratis</strong> para paquetes hasta de 40 kilogramos.</li>
              <li>Los envíos gratis podrán utilizarse durante los primeros 30 días naturales contados a partir de la activación del servicio.</li>
              <li>Para paquetes superiores a 40 kilogramos, los envíos gratis se otorgarán de forma diferida, liberándose 1 envío gratis por cada mes en que se cumpla el consumo mensual pactado, hasta agotar el total de 5 envíos.</li>
              <li>5% de descuento adicional en guías web por consumo aplicable en su primera compra, las guías físicas tienen costo adicional.</li>
          </p>
          <p>
              <b>¿Cómo funciona?</b><br>
          </p>
          <ol>
            <li><strong>Cambia tu contrato:</strong>  Si actualmente cuentas con contrato en otra paquetería, preséntanos tu historial de consumo de los últimos 3 meses.
              </li>
            <li><strong>Elige tu plan ideal:</strong>  Selecciona entre las modalidades, <strong>Prepago</strong>  o <strong>Crédito</strong>.
            </li>
            <li><strong>Activa tus beneficios:</strong>  Disfruta de envíos gratis, reembolsos y más desde el primer día con TufesaPack®.
              </li>
          </ol>
          <p>Se asignará a un ejecutivo personalizado que te guiará durante tu proceso de cambio.</p>

          <p>
              <b>Restricciones Prepago</b><br>
              <li>Comprobar el consumo previo de servicios de paquetería durante los últimos 3 meses.</li>
              <li>Los beneficios se aplican exclusivamente en modalidad de guías web.</li>
              <li>Los envíos gratuitos no estarán sujetos a las obligaciones del contrato de adhesión de “TUFESAPACK”.</li>
              <li>En caso de no cumplir el consumo mensual pactado en cualquier mes, se perderá automática y definitivamente el derecho a los envíos gratis pendientes correspondientes a paquetes superiores a 40 kilogramos, sin posibilidad de reactivación.</li>
          </p>
          <p>
              <b>Restricciones Crédito</b><br>
              <li>Comprobar el consumo previo de servicios de paquetería durante los últimos 3 meses.</li>
              <li>Los beneficios se aplican exclusivamente en modalidad de guías web.</li>
              <li>Los envíos gratuitos no estarán sujetos a las obligaciones del contrato de adhesión de “TUFESAPACK”.</li>
              <li>En caso de no cumplir el consumo mensual pactado en cualquier mes, se perderá automática y definitivamente el derecho a los envíos gratis pendientes correspondientes a paquetes superiores a 40 kilogramos, sin posibilidad de reactivación.</li>
          </p>

          <p>
              <b>Disponibilidad</b><br>
                Pakt Cambies puede solicitarse en cualquier sucursal de cobertura principal Tufesapack, 
                la aplicación del servicio y beneficios estará sujeta a la validación de disponibilidad en cada sucursal, considerando su operación.
              <br>
          </p>

          <p>
              <b>¿Por qué elegir TufesaPack®?</b><br>
              Con TufesaPack®, obtienes más que envíos rápidos y seguros; garantizamos soluciones personalizadas, 
              incentivos únicos, una experiencia confiable que mejora tu logística y reduce tus costos combinando 
              innovación y servicio para ofrecerte soluciones que realmente se ajusten a tus necesidades.<br>
<br>
              ¡Haz el cambio hoy mismo! Activa nuestro programa de portabilidad <strong>PaKTCambies</strong> y da el
              primer paso hacia un servicio de paquetería más eficiente y lleno de beneficios, donde
              hacemos más fácil y rentable tus envíos.
          </p>
          
      </div>

      <div class="container_frm">
        <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <h1 class="title-section">Solicitar Información</h1>
        <h4>Comparte tus datos y te contactamos a la brevedad</h4>
        <form class="frm-tosubmit" [formGroup]="formulario">
            <div class="cont_input">
                <input class="input-frm" placeholder="Nombre completo" autofocus id="nombre" formControlName="nombre" maxlength="50" type="text">
                <div *ngIf="userF.nombre.invalid && (userF.nombre.dirty || userF.nombre.touched)" class="text-danger">
                    <p *ngIf="userF.nombre.errors.required">El nombre es requerido.</p>
                  </div>
            </div>
            <div class="cont_input">
                <input class="input-frm" placeholder="Correo" id="correo" formControlName="correo" maxlength="50" type="email">
                <div *ngIf="userF.correo.invalid && (userF.correo.dirty || userF.correo.touched)" class="text-danger">
                    <p *ngIf="userF.correo.errors.required">El correo es requerido.</p>

                    <p *ngIf="formulario.get('correo').errors.pattern">Email inválido (Ej. ejemplocorreo&#64;gmail.com).</p>
                  </div>
            </div>
            <div class="cont_input">
                <input class="input-frm" placeholder="10 digitos" id="telefono" formControlName="telefono"  maxlength="10" type="tel" pattern="[0-9]{10}">
                <div *ngIf="userF.telefono.invalid && (userF.telefono.dirty || userF.telefono.touched)" class="text-danger">
                    <p *ngIf="userF.telefono.errors.required">El teléfono es requerido.</p>
                    <p *ngIf="formulario.get('telefono').errors.pattern">Teléfono inválido. Coloca 10 dígitos numéricos.</p>
                  </div>
            </div>
            <div class="cont_input" style="text-align: right;">
                <button class="btn btn_solicitar" [disabled]="formulario.invalid" (click)="submitForm()">Solicitar</button>
            </div>
        </form>
        <!-- <label id="mensajeAlert">{{msg}}</label> -->
      </div>
  </div>

   <!-- POPUP para mostrar mensaje -->
<div class="popup-overlay" *ngIf="isPopupOpen" (click)="closePopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <span class="x_close" (click)="closePopup()">x</span>
    <h2>¡Gracias por tu solicitud!</h2>
    <img src="assets/img/notificacion/confirm_icon.png">
    <p>{{ msg }}</p>
    <button (click)="closePopup()" class="btn_aceptar">Aceptar</button>
  </div>
</div>
</div>

